import React, { useEffect } from 'react';

// 共通モーダル：ESCで閉じる・背景スクロールロック・オーバーレイクリックで閉じる
function Modal({ onClose, label, children, variant = '' }) {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={label}
    >
      <div className={`modal-content ${variant}`} onClick={(e) => e.stopPropagation()}>
        <button type="button" className="close-button" onClick={onClose} aria-label="ปิด">
          &times;
        </button>
        {children}
      </div>
    </div>
  );
}

export default Modal;
